import { Component, OnInit } from '@angular/core';
import { ContactService } from 'src/app/services/contact.service';
import { SendMoneyService } from 'src/app/dashboard/send-money/send-money.service';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { AuthService } from 'src/app/services/auth.service';
import { Facebook } from '@ionic-native/facebook/ngx';
import { Capacitor } from '@capacitor/core';

declare var webengage
@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.scss'],
})
export class Step1Component implements OnInit {
  start = 0;
  selectedContact

  constructor(
    public contactService: ContactService,
    public sendMoneyService: SendMoneyService,
    public router: Router,
    public common: CommonService,
    public auth: AuthService,
    public fb:Facebook
  ) {}

  ngOnInit(): void {
    webengage.track("send_now_initiate",{
      // "Reciever name" : `${this.sendMoneyService.receiver.first_name || this.sendMoneyService.receiver.payee_name} ${this.sendMoneyService.receiver.last_name || ''}`,
      // "To country id" : this.sendMoneyService.receiver.country_id || this.sendMoneyService.receiver.payee_country,
      // "From country (user country)" : this.auth.user.country_id,
    })
    this.sendMoneyService.setContacts()
    this.sendMoneyService.isMarkPurpose = false;
    this.sendMoneyService.isMarkTransaction = false;
    this.sendMoneyService.isMarkConfirm = false;
    this.sendMoneyService.isMarkComplete = false;
    this.sendMoneyService.getcaPaymentOptions().subscribe((res:any)=>{
      this.sendMoneyService.caPaymentMethods=res.data
    },err=>{
    })
  }

  selectContact(contact) {
    this.sendMoneyService.receiver = contact;
    this.sendMoneyService.payment_account_type = contact.transaction_type
    this.selectedContact = contact
  }
  goAhead() {
    //console.log('go ahead');
    //this.sendMoneyService.receiver=this.selectedContact
    // this.router.navigateByUrl("/send-money/step2")
    this.sendMoneyService.goTo('step2');
  }
  title = 'assignment2';
  account_number: any;
  hide = true;
  cgi() {
    this.hide = !this.hide;
    let vis = this.account_number.slice(-4),
      countnum = '';
    for (var i = this.account_number.length - 4; i > 0; i--) {
      countnum += '*';
    }
    if (this.hide == false) this.account_number = countnum + vis;
    else this.account_number = this.account_number;
  }

  onNewContactCreated(event) {
    //console.log(event);
    if (event) {
      if(Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios'){
        this.fb.logEvent('contact_created',{
          email : this.auth.user.email
        })
      }
      this.sendMoneyService.setContacts();
      // window.location.reload();
    }
  }

  prev() {
    this.start -= 5;
  }
  next() {
    this.start += 5;
  }

  disableNext() {
    if(this.sendMoneyService.contacts.length <= 5)
      return true

    else
      // return parseInt((this.sendMoneyService.contacts.length / 5).toString()) ==
      // (this.start) / 5
      //   ? true
      //   : false;
      if(this.sendMoneyService.contacts.length%5==0){
        return parseInt((this.sendMoneyService.contacts.length / 5).toString()) == (this.start+5) / 5
        ? true
        : false;
      }
      else{
        return parseInt((this.sendMoneyService.contacts.length / 5).toString()) == (this.start) / 5
        ? true
        : false;
      }
  }

  show(){
    if(this.sendMoneyService.contacts.length<=5){
      return true
    }
    else{
      return false
    }
  }

  mobileIcon(type){
    if(type == 'Mobile'){
      return '<i class="fas fa-mobile-alt text-success"></i>'
    }
    else if(type == 'Cash'){
      return '<i class="far fa-money-bill-alt text-success"></i>'
    }
  }
}
